var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegmentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596168",
    fillRule: "evenodd",
    d: "M1.5 0h9A1.5 1.5 0 0112 1.5v5A1.5 1.5 0 0110.5 8h-9A1.5 1.5 0 010 6.5v-5A1.5 1.5 0 011.5 0zm0 10h9a1.5 1.5 0 011.5 1.5v1a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 010 12.5v-1A1.5 1.5 0 011.5 10zm1-8a.5.5 0 000 1h7a.5.5 0 100-1h-7zm0 2a.5.5 0 000 1h4a.5.5 0 000-1h-4zm0 7a.5.5 0 100 1h6a.5.5 0 100-1h-6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentIcon);
export default ForwardRef;